export function getCsvString(value?: string) {
  if (value) {
    return `="${value
      .replaceAll("#", "")
      .replaceAll('"', "'")
      .replaceAll(",", " ")
      .trim()}"`;
  }
}
